import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import * as actions from 'modules/users/actions/impersonate';

import { Modal } from '../ModalDealerSelect';
import SearchPanel from './components/search';
import UserTable from './components/Table';

const ImpersonateUserModal = () => {
  const dispatch = useDispatch();

  const handleOnClose = React.useCallback(() => {
    dispatch(actions.closeImpersonateModal());
  }, [dispatch]);

  return (
    <Modal
      open
      onCancel={handleOnClose}
      okButtonProps={{ className: 'd-none' }}
      title={<FormattedMessage id="page.login.behalf.impersonate" defaultMessage="Impersonate a user" />}
    >
      <SearchPanel />
      <UserTable />
    </Modal>
  );
};

export default ImpersonateUserModal;
